var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"msgbox"},[_c('div',{attrs:{"id":"captcha"}}),_c('cube-button',{staticClass:"vercode-btn",attrs:{"disabled":_vm.disabledCall,"type":"button"},on:{"click":_vm.openDun}},[_vm._v(_vm._s(_vm.showText))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }